const roundMillisecondsToTimeUnit = (milliseconds) => {
  const totalSeconds = milliseconds / 1000
  const totalMinutes = totalSeconds / 60
  const totalHours = totalMinutes / 60
  const totalDays = totalHours / 24

  if (totalSeconds <= 60) return `${Math.floor(totalSeconds)}s`

  if (totalHours < 1) {
    const wholeMinutes = Math.floor(totalMinutes)
    const remainingSeconds = totalSeconds % 60

    if (remainingSeconds < 20) return `${wholeMinutes}m`
    else if (remainingSeconds < 40) return `${wholeMinutes}.5m`
    else return `${wholeMinutes + 1}m`

  } else if (totalHours >= 1 && totalHours <= 24) {
    const wholeHours = Math.floor(totalHours)
    const remainingMinutes = totalMinutes % 60

    if (remainingMinutes < 20) return `${wholeHours}h`
    else if (remainingMinutes < 40) return `${wholeHours}.5h`
    else return `${wholeHours + 1}h`

  } else {
    const wholeDays = Math.floor(totalDays)
    const remainingHours = totalHours % 24

    if (remainingHours < 8) return `${wholeDays}d`
    else if (remainingHours < 17) return `${wholeDays}.5d`
    else return `${wholeDays + 1}d`
    
  }
}

export default roundMillisecondsToTimeUnit
